/**
 * Which of a revived entry's used teams it gets back (ISSUE-1326). One
 * checkbox per used team, all unchecked by default, which is the legacy
 * revive: every used team stays spent. A checked team goes to the server as
 * `teamsToRelease`, and the server decides what releasing it means.
 */
import { Checkbox } from "@sportsmet/ui";
import type { JSX } from "react";

import {
  RELEASE_TEAMS_HELP,
  RELEASE_TEAMS_NONE_LINE,
  releaseTeamsLabel,
} from "./reviveSheetModel";

export type typeReleaseTeamsListProps = {
  name: string;
  teams: readonly { teamId: string; name: string }[];
  selectedTeamIds: readonly string[];
  onChange: (next: string[]) => void;
  disabled?: boolean | undefined;
};

export function ReleaseTeamsList(
  props: typeReleaseTeamsListProps,
): JSX.Element {
  const { name, teams, selectedTeamIds, onChange, disabled = false } = props;

  return (
    <fieldset className="flex flex-col gap-2" data-testid="revive-release">
      <legend className="text-body-strong text-ink">
        {releaseTeamsLabel({ name })}
      </legend>
      {teams.length === 0 ? (
        <p
          className="text-caption text-ink-secondary"
          data-testid="revive-release-none"
        >
          {RELEASE_TEAMS_NONE_LINE}
        </p>
      ) : (
        <>
          <p className="text-caption text-ink-secondary">
            {RELEASE_TEAMS_HELP}
          </p>
          <div className="flex flex-col gap-2">
            {teams.map((team) => (
              <Checkbox
                key={team.teamId}
                label={team.name}
                name="revive-release-team"
                value={team.teamId}
                disabled={disabled}
                checked={selectedTeamIds.includes(team.teamId)}
                onCheckedChange={(checked) => {
                  onChange(
                    checked === true
                      ? [...selectedTeamIds, team.teamId]
                      : selectedTeamIds.filter((id) => id !== team.teamId),
                  );
                }}
              />
            ))}
          </div>
        </>
      )}
    </fieldset>
  );
}
